module.exports = __webpack_public_path__ + "img/filtrar-bordes-azul.9f191be3.svg";